export const useRedeemedRewardsModal = (props) => {
    return {
        rewards: props.rewards,
    };
};
